import { inject, injectable } from "inversify";
import {
  ICPLClientPortalJobsClient,
  ClientPortalJobDetailsModel,
  ClientPortalJobFiltersModel,
  ClientPortalJobOverviewModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalJobsService {
  getJobs(jobsFiltersModel: ClientPortalJobFiltersModel): Promise<ClientPortalJobOverviewModel[]>;
  getJobFromJobID(jobID: number, taskSeqNo: number): Promise<ClientPortalJobDetailsModel>;
  getJobFromEstimateRequestID(estimateRequestID: string): Promise<ClientPortalJobDetailsModel>;
}

@injectable()
export class ClientPortalJobsService implements IClientPortalJobsService {
  @inject(SERVICE_TYPES.CPLClientPortalJobsClient) cplClientPortalJobsClient!: ICPLClientPortalJobsClient;

  async getJobs(jobsFiltersModel: ClientPortalJobFiltersModel): Promise<ClientPortalJobOverviewModel[]> {
    return await this.cplClientPortalJobsClient.getJobs(jobsFiltersModel);
  }

  async getJobFromJobID(jobID: number, taskSeqNo: number): Promise<ClientPortalJobDetailsModel> {
    return await this.cplClientPortalJobsClient.getJobFromJobID(jobID, taskSeqNo);
  }

  async getJobFromEstimateRequestID(estimateRequestID: string): Promise<ClientPortalJobDetailsModel> {
    return await this.cplClientPortalJobsClient.getJobFromEstimateRequestID(estimateRequestID);
  }
}
